import type { ContactInfo } from "./types";

export const CONTACT_INFO: ContactInfo = {
  address: "Караганда, проспект Нурсултана Назарбаева, 68/1",
  phone: "+7 778 629 27 90",
  email: "baldaionim@gmail.com",
  hours: [{ days: "Daily", time: "07:00 – 18:00" }],
  // [longitude, latitude] of проспект Нурсултана Назарбаева 68/1, Караганда.
  coordinates: [73.10956, 49.81591],
  youtubeId: "YOUR_VIDEO_ID"
};
